<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row v-for="(cashToMaster, index) in cashToMasters" :key="'cash-to-master-' + index">
        <v-col cols="12" class="pb-0">
          <span class="text-h6">Cash To Master: #{{index + 1}}</span>
          <v-btn color="red" icon @click="removeServiceEntry(index, cashToMaster.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="!operation.is_draft">
          <v-switch
            dense
            hide-details
            v-model="cashToMaster.metadata.arrange_by_owner"
            label="Arrange By Principal?"
            class="mt-0 pt-0"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner">
          <v-text-field
            label="Cash Amount"
            placeholder="Enter Cash Amount"
            :rules="[rules.negative]"
            outlined
            dense
            type="number"
            v-model="cashToMaster.amount"
            prepend-inner-icon="mdi-wallet"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner">
          <v-select
            label="Currency"
            placeholder="Select a currency"
            :rules="[rules.required]"
            outlined
            dense
            v-model="cashToMaster.metadata.currency"
            prepend-inner-icon="mdi-cash"
            :items="currencies"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Percentage(charges)"
            placeholder="Enter percentage"
            type="number"
            :rules="[rules.required, rules.negative]"
            outlined
            dense
            v-model="cashToMaster.metadata.percentage"
            prepend-inner-icon="mdi-percent"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Bank Charges"
            placeholder="Enter bank charges"
            type="number"
            :rules="[rules.negative]"
            outlined
            dense
            v-model="cashToMaster.metadata.bank_charges"
            prepend-inner-icon="mdi-cash"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner">
          <v-select
            label="Supplier"
            placeholder="Select a supplier"
            outlined
            dense
            v-model="cashToMaster.card_id"
            prepend-inner-icon="mdi-account"
            :items="suppliers"
            :rules="supplierRules[index]"
            :disabled="isDisabled"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!cashToMaster.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-select
            label="Tax"
            placeholder="Select Tax"
            outlined
            dense
            v-model="cashToMaster.metadata.tax"
            prepend-inner-icon="mdi-cash-fast"
            :items="taxes"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-textarea
            label="Remarks"
            placeholder="Enter Remarks"
            outlined
            dense
            hide-details
            :rows="2"
            v-model="cashToMaster.remarks"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
          <v-textarea
            label="Accounts Remarks"
            placeholder="Enter Accounts Remarks"
            outlined
            background-color="light-blue lighten-5"
            dense
            hide-details
            :rows="2"
            v-model="cashToMaster.accounts_remarks"
            class="accounts-remarks-field"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-col cols="12" class="pt-7">
        <v-btn color="primary" @click="addCashToMaster">Add</v-btn>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
          @click="saveDetails">Save</v-btn>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';

  export default {
    name: 's-services-opted-cashtomaster-service',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      servicesOpted: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        loading: false,
        isDisabled: false,
        form: false,
        rules,
        cashToMasters: [],
        sinodaSupplier: null,
        serviceOptForm: {
          service_catalog_id: null,
          card_id: null,
          amount: 0,
          bill_type: "Cash To Master",
          metadata: {
            arrange_by_owner: false,
            percentage: 1.5,
            currency: 'USD',
            bank_charges: 40,
            tax: ''
          },
          remarks: '',
          accounts_remarks: '',
        },
        suppliers: [],
        currencies: ["USD", "SGD", "EURO"],
        taxes: ['0%', '9%']
      };
    },
    methods: {
      getDefaultMetadata() {
        return JSON.parse(JSON.stringify(this.serviceOptForm.metadata));
      },
      normalizeMetadata(rawMetadata) {
        const base = this.getDefaultMetadata();
        let fromApi = rawMetadata;
        if (typeof fromApi === 'string') {
          try {
            fromApi = JSON.parse(fromApi);
          } catch (e) {
            fromApi = {};
          }
        }
        if (!fromApi || typeof fromApi !== 'object' || Array.isArray(fromApi)) {
          fromApi = {};
        }
        const merged = { ...base, ...fromApi };
        if (merged.currency == null || merged.currency === '') merged.currency = base.currency;
        if (merged.percentage == null || merged.percentage === '') merged.percentage = base.percentage;
        if (merged.bank_charges == null || merged.bank_charges === '') merged.bank_charges = base.bank_charges;
        if (merged.tax == null) merged.tax = base.tax;
        merged.arrange_by_owner = !!merged.arrange_by_owner;
        return merged;
      },
      normalizeRow(service = {}) {
        return {
          ...service,
          card_id: service.card_id || this.sinodaSupplier,
          metadata: this.normalizeMetadata(service.metadata),
          amount: service.amount ? parseFloat(service.amount).toFixed(2) : 0,
        };
      },
      removeServiceEntry(index, serviceId) {
        if (!serviceId) {
          this.cashToMasters.splice(index, 1);
          return;
        }
        this.loading = true;
        this.$api.operation_billed_items.remove_service_entry(serviceId, { index })
          .then(() => {
            const indexOfService = this.servicesOpted.findIndex(s => s.id === serviceId);
            if (indexOfService !== -1) {
              this.servicesOpted.splice(indexOfService, 1);
            }
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Service entry removed successfully',
            });
            this.cashToMasters.splice(index, 1);
          })
          .catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      submit() {
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      initServiceOptedDetails() {
        const services = (this.servicesOpted || []).filter((s) => s.bill_type === 'Cash To Master');
        if (services.length) {
          const newServices = services.filter(service => 
              service.card_id !== null || (service.card_id === null && service.id) || (service.card_id === null && this.normalizeMetadata(service.metadata).arrange_by_owner === true)
            );
          if (newServices.length > 0) {
            this.cashToMasters = newServices.map((service) => this.normalizeRow(service));
          } else {
            this.cashToMasters = [this.normalizeRow(JSON.parse(JSON.stringify(this.serviceOptForm)))];
          }
        } else {
          this.addCashToMaster();
        }
      },
      populateSuppliers() {
        const catalogReq = this.$api.service_catalogs.get_suppliers_list('Cash To Master');
        const cardReq = this.operation.card_id ? this.$api.cards.getCard(this.operation.card_id) : Promise.resolve(null);
        Promise.all([catalogReq, cardReq])
          .then(([catalogResponse, cardResponse]) => {
            if (cardResponse?.card) {
              if (cardResponse.card.ctm_percentage != null && cardResponse.card.ctm_percentage !== '') {
                this.serviceOptForm.metadata.percentage = cardResponse.card.ctm_percentage;
              }
              if (cardResponse.card.ctm_bank_charges != null && cardResponse.card.ctm_bank_charges !== '') {
                this.serviceOptForm.metadata.bank_charges = cardResponse.card.ctm_bank_charges;
              }
            }
            this.suppliers = catalogResponse.suppliers;
            if (this.suppliers && this.suppliers.length > 0) {
              this.sinodaSupplier = this.suppliers[0].id;
              this.isDisabled = true;
            }
            this.serviceOptForm.service_catalog_id = catalogResponse.service_catalog_id;
            this.initServiceOptedDetails();
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      saveDetails() {
        if(!this.submit()) return;
        this.loading = true;
        this.cashToMasters = this.cashToMasters.map(service => {
          service.service_catalog_id = this.serviceOptForm.service_catalog_id;
          service.operation_id = this.operation.id;

          return service;
        });

        // Loop through cashToMasters array to save each service
        Promise.all([
          ...[...this.cashToMasters].map(service => {
            const apiType = service.id ? "update" : "save_service";
            return this.$api.operation_billed_items[apiType](service, true)
          })
        ]).then((response) => {
          response.forEach(service => {
            service = service.operation_billed_item;
            const indexOfService = this.servicesOpted.findIndex(s => s.id === service.id);
            if (indexOfService !== -1) {
              this.$set(this.servicesOpted, indexOfService, service);
            } else {
              this.servicesOpted.push(service);
            }
          });
          this.initServiceOptedDetails();
          this.$store.dispatch('setAlert', {
            status: 'success',
            show: true,
            message: 'Cash to master service updated successfully',
          });
        }).catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
        }).finally(() => (this.loading = false));
      },
      addCashToMaster() {
        const newCashToMaster = this.normalizeRow(JSON.parse(JSON.stringify(this.serviceOptForm)));
        this.cashToMasters.push(newCashToMaster);
      },
    },
    watch: {
      operation(value) {
        this.handleOperationInit();
      },
    },
    computed: {
      supplierRules() {
        return this.cashToMasters.map(service => {
          if (service.metadata.arrange_by_owner) {
            return [];
          } else {
            return [this.rules.required];
          }
        });
      }
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>